import React, { FC } from 'react';
import _ from 'lodash';
import { Svg, GetTradingBlockSiteName } from '@tradingblock/components';
import { useStateSelector } from '../../data/global/dataSelectors';
import { useFeatureFlag } from '@tradingblock/components';

const LoginCountStatusIconButton: React.FC<{ cssClasses?: string; title?: string; icon: string }> = ({
  title,
  cssClasses,
  icon,
}) => {
  return (
    <button className="dashboard-nav-tool dashboard-nav-tool-btn" type="button" onClick={() => { }}>
      <span className={`tb-icon tb-icon-2x tb-icon-stack tb-icon-clipboard ${cssClasses || ''}`} title={title}>
        <span className="tb-icon tb-icon-stack-2x">
          <Svg path="icon-clipboard" />
        </span>
        <span className="tb-icon tb-icon-stack-1x">
          <Svg path={`icon-${icon}`} />
        </span>
      </span>
    </button>
  );
};

export const LoginCountStatusIcon: FC = () => {
  const feedInfo = useStateSelector(s => {
    const { status, message, isReconnecting } = s.loginCountProvider;
    const isClosed = status === 'closed';
    const isConnected = status === 'open';
    const isError = status === 'error' ? true : isClosed && isReconnecting === false ? true : false;
    return { status, message, isConnected, isError, isWarning: isClosed, isPending: status === undefined };
  });
  const loginCount = useStateSelector(s => s.loginCount && s.loginCount.loginCount);
  const { isEnabled: useLofiLoginCount } = useFeatureFlag('lofi-login-count');

  if (feedInfo.isConnected) {
    return (
      <div
        className="dashboard-nav-account-item"
        style={{ display: 'flex', alignItems: 'center', color: 'var(--yellow)' }}
      >
        <span>
          <i className="fas fa-lg fa-users" /> {loginCount}
        </span>
      </div>
    );
  }

  const cssClasses = feedInfo.isError ? 'neg' : feedInfo.isWarning ? 'warn' : feedInfo.isPending ? 'pending' : '';
  const title = feedInfo.message
    ? feedInfo.message
    : feedInfo.isPending
      ? 'Connecting...'
      : `Cannot connect to ${GetTradingBlockSiteName()} API`;
  return (
    <>
      {(feedInfo.isError || feedInfo.isWarning || feedInfo.isPending) && useLofiLoginCount && (
        <LoginCountStatusIconButton icon="lightning" cssClasses={cssClasses} title={title} />
      )}
    </>
  );
};
